<template>
  <div 
    class="file-upload"
    :class="{'file-upload__error': hasError}"
  >
    <label class="file-upload__label">
      <span class="file-upload__label-text">Прикріпити файл</span>
      <Clip />
      <input
        ref="fileInput"
        class="file-upload__input"
        type="file"
        multiple
        @change="onFileSelection()"
      >
    </label>
  

    <ul 
      v-if="files.length > 0"
      class="file-upload__list"
    >
      <li
        v-for="(file, index) in files"
        :key="index"
        class="file-upload__item"
      >
        <span class="file-upload__item-text">{{ file.name }}</span>
        <span class="file-upload__item-delete" @click="removeFile(index)" />
      </li>
    </ul>

    <div 
      v-if="hasError"
      class="file-upload__error-text"
    >
      На жаль, обсяг Вашого файлу перевищив рекомендований нами. Будь ласка, завантажте Вашу ідею на будь-який файлообмінник та надішліть нам посилання. Дякуємо!
    </div>
  </div>
</template>

<script>

  import Clip from '@/assets/svg/clip.svg'
  export default {
    name: 'BaseFile',

    components: {
      Clip
    },

    props: {
      value: {
        type: Array,
        default: () => []
      }
    },

    data () {
      return {
        files: [],
        input: null,
        hasError: false,
        maxSize: 20,
        count: 0
      }
    },
  
    watch: {
      files (files) {
        // console.log(files)
        this.$emit('input', files)
      },
      hasError (hasError) {
        this.bus.$emit('fileHasError', hasError)
      }
    },

    mounted () {
      if (this.value) {
        this.files = this.value
      } else {
        this.$emit('input', [])
      }
    },

    methods: {
      onFileSelection () {
        for (const file of this.$refs.fileInput.files) {
          if (this.files.length > 0) {
            for (let i = 0; i < this.files.length; i++) {
              if (this.files[i].name === file.name) return
            }
          }
          this.count += file.size
          this.hasError = false

          if (this.count > this.maxSize * 1e+6) {
            this.hasError = true
          }
          this.files.push(file)
        }
      
        this.$refs.fileInput.value = null
      },

      removeFile (index) {
        this.files.splice(index, 1)
        this.count = 0
        for (let i = 0; i < this.files.length; i++) {
          this.count += this.files[i].size
        }
        if (this.count < this.maxSize * 1e+6) {
          this.hasError = false
        }
      },
    
      showUpload () {
        const event = new MouseEvent('click', {
          'view': window,
          'bubbles': true,
          'cancelable': true
        })
        console.log(event)
        this.input.dispatchEvent(event)
      }
    }
  }
    
</script>

<style lang="scss">
.file-upload {
  position: relative;
  display: inline-flex;
  align-items: flex-end;
  flex-direction: column;
  width: 100%;
  max-width: 300px;

  @include mobile {
    max-width: 100%;
    align-items: flex-start;
    margin-top: 24px;
  }

  &__input {
    display: none;
  }

  &__label {
    display: inline-flex;
    align-items: center;
    padding: 9.5px 25px;
    border: 2px solid $c-yellow;
    border-radius: 50px;
    cursor: pointer;

    @include mobile {
      width: 100%;
      justify-content: center;
    }

    svg {
      margin-left: 13px;
    }

    &-text {
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      color: $c-yellow;
      text-transform: uppercase;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;

    @include mobile {
      width: 100%;
    }
  }

  &__item {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 11px;

    &-text {
      color: $c-yellow;
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      margin-right: 14px;
    }

    &-delete {
      position: relative;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background-color: rgba($c-yellow, 0.2);
      display: inline-block;
      cursor: pointer;

      &::before,
      &::after {
        position: absolute;
        width: 12px;
        height: 2px;
        background-color: $c-yellow;
        transform: rotate(45deg);
        left: 8px;
        top: 13px;
        content: '';
      }

      &::after {
        transform: rotate(-45deg);
      }
    }
  }

  &__error-text {
    margin-top: 11px;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    font-size: 14px;
    line-height: 1.34;
    color: $c-red;
    transition: 0.3s;
  }

  &__error {
    .file-upload__error-text {
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>
